let drinkWarnInfo = null // 喝水提醒信息
let pillsWarnInfo = null // 吃药提醒信息
let tomatoWarnInfo = null // 番茄提醒信息
let pillsTimes = null // 吃药提醒时间

export default {
  drinkWarnInfo,
  pillsWarnInfo,
  tomatoWarnInfo,
  pillsTimes
}



// WEBPACK FOOTER //
// ./src/store/state.js